const weekIndex = () => import("@/views/week-module/index.vue");
const weekDetail = () => import("@/views/week-module/detail.vue");
const weekWorkDetail = () => import("@/views/week-module/work-detail.vue");

let router = [
  {
    path: "/week/index",
    name: "weekIndex",
    component: weekIndex,
    meta: {
      title: "周练"
    }
  },
  {
    path: "/week/detail",
    name: "weekDetail",
    component: weekDetail,
    meta: {
      title: "周练详情"
    }
  },
  {
    path: "/week/workDetail",
    name: "weekWorkDetail",
    component: weekWorkDetail,
    meta: {
      title: "作业详情"
    }
  }
];
export default router;



// WEBPACK FOOTER //
// ./src/router/week/index.js